import type { useTranslation } from "react-i18next";

type TFunc = ReturnType<typeof useTranslation>["t"];

/** Translate an AI tool name via i18n, falling back to a humanized form. */
export function translateToolName(toolName: string, t: TFunc): string {
  const tKey = `ai.toolNames.${toolName}`;
  const translated = t(tKey);
  if (translated !== tKey) return translated;
  return toolName.replaceAll("_", " ").replace(/^\w/, (c) => c.toUpperCase());
}
